"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagBnIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagBnIcon = (0, _mobxReact.observer)(_class = (_FlagBnIcon = /*#__PURE__*/function (_React$Component) {
  function FlagBnIcon() {
    _classCallCheck(this, FlagBnIcon);
    return _callSuper(this, FlagBnIcon, arguments);
  }
  _inherits(FlagBnIcon, _React$Component);
  return _createClass(FlagBnIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 100 100",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#006A4E",
        x: "0",
        y: "0",
        width: "100",
        height: "100"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        fill: "#FF5252",
        cx: "50",
        cy: "50",
        r: "32.5"
      }))));
    }
  }]);
}(_react["default"].Component), _FlagBnIcon.defaultProps = {
  width: '20px'
}, _FlagBnIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagBnIcon);